<router-outlet></router-outlet>

<!-- QR Code Lightbox -->
@if (qrcodeLightboxService.isOpen$ | async) {
<div class="qrcode-lightbox-overlay" (click)="closeLightbox()">
    <div class="qrcode-lightbox-container" (click)="$event.stopPropagation()">
        <button mat-icon-button class="close-button" (click)="closeLightbox()">
            <mat-icon>close</mat-icon>
        </button>

        @if (qrcodeLightboxService.qrCodeData$ | async; as qrData) {
        <div class="qrcode-image-wrapper">
            <img [src]="qrData.imageUrl" alt="QR Code" class="qrcode-large" />
        </div>
        }
    </div>
</div>
}